export default __webpack_public_path__ + "static/media/activity2.05f45447.jpg";